import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button } from "@material-ui/core";
import Kjordaemifilter from "pages/urvinnslur/components/filters/KjordaemiFilter";
import KjorstadirFilter from "pages/urvinnslur/components/filters/KjorstadirFilter";
import SveitarfelagFilter from "pages/urvinnslur/components/filters/SveitarfelagFilter";
import TimeFilter from "pages/urvinnslur/components/TimeFilter";
import KosningSelect from "pages/tolfraedi/components/KosningSelect";
import { createQueryParamsFromFilters } from "common/services/apiService";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: '32px'
  },
  titleSection: {
    textAlign: 'left',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  titleText: {
    textTransform: 'uppercase',
    borderBottom: '3px solid',
    borderBottomColor: theme.palette.primary.main,
    },
    button: {
        marginTop: "16px"
    }
}));

export default function AtkvaedalistiByKjordaemi() {
  const classes = useStyles();
  const [kosningId, setKosningId] = useState('');
  const [filters, setFilters] = useState(null);
  const [kjordaemisnumerFromFilter, setKjordaemisnumerFromFilter] = useState('');
  const [kjorstadirFromFilter, setKjorstadirFromFilter] = useState([]);
  const [sveitarfelagsnumerFromFilter, setSveitarfelagsnumerFromFilter] = useState('');

  const downloadAtkvaedalistiByKjordaemiReport = () => {
    let queryParams = createQueryParamsFromFilters(filters);
    const url = `/api/urvinnsla/atkvaedalisti/${kosningId}?${queryParams}`;

    window.open(url);
  }

  const validate = () => {
    if (filters !== null && kosningId !== '') {
      if (filters.kjordaemisnumer !== undefined && filters.kjordaemisnumer !== '') {
        return true;
      }
    }

    return false;
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.titleSection} variant="h5" component="h2">
        <strong className={classes.titleText}>Sækja atkvæðalista eftir kjördæmi</strong>
      </Typography>
      <Typography style={{ marginTop: "16px", marginBottom: "8px" }}>
        Aðgerðin skilar Excel skjali sem inniheldur öll atkvæði þeirra sem eru á kjörskrá í gefnu kjördæmi.
      </Typography>
      <Grid container direction="row">
        <KosningSelect setKosningId={setKosningId} />
      </Grid>
      <Grid
        container
        direction="row"
        spacing={2}
        alignItems="center"
        justify="flex-start"
      >
        <Grid item>
          <Kjordaemifilter
            setFilters={setFilters}
            setKjordaemisnumerFromFilter={setKjordaemisnumerFromFilter}
          />
        </Grid>
        <Grid item>
          <SveitarfelagFilter
            setFilters={setFilters}
            setSveitarfelagsnumerFromFilter={setSveitarfelagsnumerFromFilter}
            kjordaemisnumer={kjordaemisnumerFromFilter}
            kjorstadir={kjorstadirFromFilter}
            disabled={!validate()}
          />
        </Grid>
        <Grid item>
          <KjorstadirFilter
            setFilters={setFilters}
            kjordaemisnumer={kjordaemisnumerFromFilter}
            sveitarfelagsnumer={sveitarfelagsnumerFromFilter}
            setKjorstadirFromFilter={setKjorstadirFromFilter}
            disabled={!validate()}
          />
              </Grid>
        </Grid>
        <Grid container direction="row" spacing={2} justify="flex-start" >
            <Grid item>
                <TimeFilter
                    label={'Dagsetning/tími frá'}
                    filterName={'fra'}
                    setFilters={setFilters}
                />
            </Grid>
            <Grid item>
                <TimeFilter
                    label={'Dagsetning/tími til'}
                    filterName={'til'}
                    setFilters={setFilters}
                />
            </Grid>

            <Grid item>
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={downloadAtkvaedalistiByKjordaemiReport}
                disabled={!validate()}
               >
                    Sækja lista
              </Button>
            </Grid>
        
      </Grid>
      <Typography variant="caption" color="secondary">
        Athugið að nauðsynlegt er að velja kjördæmi til að sækja lista
      </Typography>
    </div>
  );
}
